export const data = [
  [
    1, 3, 5, 7, 4, 2, 8, 5, 7, 5, 8, 1, 5, 7, 3, 2, 5, 8, 9, 4, 3, 7, 4, 6, 1, 9, 8, 3, 2, 8, 1, 8,
    2, 6, 3, 6, 9, 2, 4, 9, 4, 6, 1, 3, 1, 6, 9, 6, 3, 7, 2, 8, 3, 6, 5, 9, 3, 7, 8, 5, 4, 2, 9, 6,
    7, 6, 4, 2, 1, 7, 9, 8, 7, 5, 1, 4, 5, 9, 4, 1, 2, 9, 3, 1, 5, 8, 2, 4, 2, 5, 3, 1, 6, 7, 2, 1,
    3, 5, 7, 4, 2,
  ],
  [
    1, 3, 5, 7, 4, 2, 8, 5, 7, 5, 8, 1, 5, 7, 3, 2, 5, 8, 9, 4, 3, 7, 4, 6, 1, 9, 8, 3, 2, 8, 1, 8,
    2, 6, 3, 6, 9, 2, 4, 9, 4, 6, 1, 3, 1, 6, 9, 6, 3, 7, 2, 8, 3, 6, 5, 9, 3, 7, 8, 5, 4, 2, 9, 6,
    7, 6, 4, 2, 1, 7, 9, 8, 7, 5, 1, 4, 5, 9, 4, 1, 2, 9, 3, 1, 5, 8, 2, 4, 2, 5, 3, 1, 6, 7, 2, 1,
    3, 5, 7, 4, 2,
  ],
  [
    1, 3, 5, 7, 4, 2, 8, 5, 7, 5, 8, 1, 5, 7, 3, 2, 5, 8, 9, 4, 3, 7, 4, 6, 1, 9, 8, 3, 2, 8, 1, 8,
    2, 6, 3, 6, 9, 2, 4, 9, 4, 6, 1, 3, 1, 6, 9, 6, 3, 7, 2, 8, 3, 6, 5, 9, 3, 7, 8, 5, 4, 2, 9, 6,
    7, 6, 4, 2, 1, 7, 9, 8, 7, 5, 1, 4, 5, 9, 4, 1, 2, 9, 3, 1, 5, 8, 2, 4, 2, 5, 3, 1, 6, 7, 2, 1,
    3, 5, 7, 4, 2,
  ],
];

export const testData1 = [
  1, 3, 5, 7, 4, 2, 8, 5, 7, 5, 8, 1, 5, 7, 3, 2, 5, 8, 9, 4, 3, 7, 4, 6, 1, 9, 8, 3, 2, 8, 1,
];
